export default __webpack_public_path__ + "img/kiosk.97b7ce49.png";